// extracted by mini-css-extract-plugin
var _1 = "ra-filter-color-palette";
var _2 = "ra-filter-color-palette-item";
var _3 = "ra-filter-color-palette-label";
var _4 = "ra-filter-color-palette-simple";
export { _1 as "filterColorPaletteCls", _2 as "filterColorPaletteItemCls", _3 as "filterColorPaletteLabelCls", _4 as "filterColorPaletteSimpleCls" }
